/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'

import { pageTitleCss } from '../../../../lib/styles/typography'
import { srOnlyCss } from '../../../../lib/styles/cssStyles'

const h2Css = css`
  ${pageTitleCss}
  margin: 0;
`

type H2Props = {
  /** Children React Components  */
  children: React.ReactNode
  /** Optional class name */
  className?: string
  /** Render for screen-readers only */
  srOnly?: boolean
}

const defaultProps: Pick<H2Props, 'className' | 'srOnly'> = {
  className: undefined,
  srOnly: false
}

const H2 = ({ children, className, srOnly }: H2Props) => {
  const srCss = srOnly ? srOnlyCss : h2Css
  return (
    <h2 className={className} css={srCss}>
      {children}
    </h2>
  )
}

H2.defaultProps = defaultProps

export default H2
